import React from 'react';

export default (): JSX.Element => {
  return (
    <svg width={12} height={12} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.078 0c.136.02 2.28 2.156 6.438 6.406.323.334.484.735.484 1.203 0 .468-.167.87-.5 1.202-.5.5-1.422 1.402-2.766 2.704A1.66 1.66 0 017.53 12c-.468 0-.874-.167-1.218-.5C2.115 7.333.01 5.193 0 5.078v-3.39C0 1.218.167.82.5.492.833.164 1.23 0 1.688 0h3.39zm-2.79 3.71c.194.194.43.29.712.29a.96.96 0 00.71-.29C3.905 3.52 4 3.28 4 3a.96.96 0 00-.29-.71A.954.954 0 003 2a.96.96 0 00-.71.29A.954.954 0 002 3c0 .28.096.518.29.71z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
